/** shadcn-style Skeleton — pulse placeholder over warm surface tint. */
import * as React from 'react';
import { cn } from '@/lib/utils';

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement>;

function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded-sm bg-line-2', className)}
      role="status"
      aria-busy="true"
      aria-live="polite"
      {...props}
    />
  );
}

export { Skeleton };
